'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Portrait-module_portraitHeader__XqVdX{margin-bottom:1rem}.Portrait-module_feedbackBox__dA0ff{margin-top:1rem}.Portrait-module_feedbackAction__EklVb{margin:.25rem 0 .5rem}";
var styles = {"portraitHeader":"Portrait-module_portraitHeader__XqVdX","feedbackBox":"Portrait-module_feedbackBox__dA0ff","feedbackAction":"Portrait-module_feedbackAction__EklVb"};
styleInject["default"](css_248z, '9c94b863-b3e6-4a87-abf4-109ea4d8c781');

exports["default"] = styles;
